import React, { useEffect, useState } from 'react';
import classes from "./ProfilePage.module.css";
import Cookies from "js-cookie";
import { checkSubscriptionApi, deactivateApi, subscriptionLogsApi } from '../Http/http';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Loader from '../Components/Loader';
import { toast } from 'react-toastify';

const ProfilePage = () => {

    const [loading, setLoading] = useState(true);
    const [subscriptionLogs, setSubscriptionLogs] = useState(null);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    // const [renewalLogs, setRenewalLogs] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [logoutModal, setLogoutModal] = useState(false);
    const navigate = useNavigate();

    const onBack = () => {
        navigate("/home");
    }

    const checkSubscription = async () => {
        try {
            setLoading(true);


            const responseLogin = await checkSubscriptionApi({ msisdn: Cookies.get("msisdn") });

            console.log(responseLogin?.data?.result);

            if (responseLogin?.data?.result?.statusCode == 401) {
                console.log("low balance==");
                Cookies.remove("msisdn");
                toast.error("Low Balance, Please Recharge your account!");
                navigate("/");
                return;
            }

            if (responseLogin?.data?.result?.statusCode == 403) {
                console.log("not subscribed");
                Cookies.remove("msisdn");
                toast.error("Your Subscription has been expired!");
                navigate("/");
                return;
            }

            subscriptionLogsApi({ msisdn: Cookies.get("msisdn") }).then((response) => {
                console.log(response, 'd');
                setLoading(false);
                setSubscriptionLogs(response?.data?.result);
                // setRenewalLogs(response?.data?.chargingData);
            }).catch(err => {
                console.log("error----", err);
                setLoading(false);
                alert("Try Reload! Something Went Wrong!");
            })

            // setLoading(false);
        } catch (error) {
            setLoading(false);
            alert("Something Went Wrong!");
        }
    }

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            checkSubscription();
        }
        else {
            navigate("/payment");
        }
    }, []);

    const handleDeactivate = async () => {
        try {
            setDeactivateLoading(true);
            const response = await deactivateApi({ msisdn: Cookies.get("msisdn") });
            console.log(response?.data?.result, 'response===');
            if (response?.data?.result?.statusCode == 200 && response?.data?.result?.message == "Successful") {
                setDeactivateLoading(false);
                setShowModal(false);
                navigate("/deactivation");
            }
            else {
                toast.error(response?.data?.result?.message ?? "Something Went Wrong!");
            }
        } catch (error) {
            setDeactivateLoading(false);
            toast.error("Error Try Again!");
        }
    }

    return (
        <div className={classes.pageWrapper}>

            <div className={classes.header}>
                <div className={classes.header_1}>
                    <button className={classes.backButton} onClick={onBack}>
                        <FaArrowLeft size={20} />
                    </button>
                    {/* <h1 className={classes.heading}>My Profile</h1> */}
                </div>

                {/* <div className={classes.actionButtons}>
                    <button type="button" className={classes.deactivate_button}
                        onClick={() => setShowModal(true)}
                    >
                        Deactivate
                    </button>
                    <button type="button" className={classes.logout_button}
                        onClick={() => {
                            Cookies.remove('msisdn');
                            navigate("/payment");
                        }}
                    >
                        Logout
                    </button>
                </div> */}
            </div>

            {loading ? <Loader /> : (
                <>
                    <div className={classes.section}>
                        <h2 className={classes.sectionHeading}>Subscription Details</h2>

                        <div className={classes.cardList}>
                            <div className={classes.card}>
                                <p><strong>Pack:</strong> {subscriptionLogs?.pack_type}</p>
                                <p><strong>Status:</strong> Active</p>
                                <p><strong>Msisdn:</strong> {subscriptionLogs?.msisdn}</p>
                                {/* <p><strong>Registration Date:</strong> {new Date(subscriptionLogs?.subDateTime).toLocaleDateString()}</p> */}
                                {/* <p><strong>Next Renewal Date:</strong> {new Date(subscriptionLogs?.nextBilledDateTime).toLocaleDateString()}</p> */}
                                <p>
                                    <strong>Registration Date:</strong>{" "}
                                    {new Date(subscriptionLogs?.subDateTime).toLocaleString("en-GB", {
                                        timeZone: "Asia/Dhaka", // GMT+6
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                    {" "}(GMT+6)
                                </p>
                                <p>
                                    <strong>Next Renewal Date:</strong>{" "}
                                    {new Date(subscriptionLogs?.nextBilledDateTime).toLocaleString("en-GB", {
                                        timeZone: "Asia/Dhaka", // GMT+6
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                    {" "}(GMT+6)
                                </p>
                                <p><strong>Price:</strong> {subscriptionLogs?.amount} BDT</p>
                                <p><strong>(Including all taxes) + Auto Renewable</strong></p>
                                <p><strong>Support:</strong> <a href="mailto:support@cloud7bd.com">support@cloud7bd.com</a></p>
                                <p><strong>Helpline:</strong> <a href="tel:8801957931782">01957931782</a></p>
                            </div>

                            <div className={classes.actionButtons}>
                                <button type="button" className={classes.deactivate_button}
                                    onClick={() => setShowModal(true)}
                                >
                                    Deactivate
                                </button>
                                <button type="button" className={classes.logout_button}
                                    onClick={() => {
                                        setLogoutModal(true);
                                        // Cookies.remove('msisdn');
                                        // navigate("/payment");
                                    }}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modal}>
                        <h3>Confirm Deactivation</h3>
                        <p>Are you sure you want to deactivate your subscription?</p>
                        <div className={classes.modalActions}>
                            <button onClick={() => setShowModal(false)}
                                disabled={deactivateLoading}
                            >Cancel</button>
                            <button onClick={handleDeactivate}
                                disabled={deactivateLoading}
                                className={classes.confirmButton}>
                                {deactivateLoading ? "Please Wait..." : "Yes, Deactivate"}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {logoutModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modal}>
                        <h3>Do you want to logout?</h3>
                        {/* <p>Do you want to logout?</p> */}
                        <div className={classes.modalActions} style={{marginTop:"20px"}}>
                            <button onClick={() => setLogoutModal(false)}
                            >No</button>
                            <button onClick={() => {
                                Cookies.remove('msisdn');
                                navigate("/payment");
                            }}
                                className={classes.confirmButton}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProfilePage